export const DEFAULT_SIGNUP_TIMEZONE = "America/New_York";

const STATE_TIMEZONES = {
  AK: "America/Anchorage",
  AL: "America/Chicago",
  AR: "America/Chicago",
  AZ: "America/Phoenix",
  CA: "America/Los_Angeles",
  CO: "America/Denver",
  CT: "America/New_York",
  DC: "America/New_York",
  DE: "America/New_York",
  FL: "America/New_York",
  GA: "America/New_York",
  HI: "Pacific/Honolulu",
  IA: "America/Chicago",
  ID: "America/Boise",
  IL: "America/Chicago",
  IN: "America/Indiana/Indianapolis",
  KS: "America/Chicago",
  KY: "America/New_York",
  LA: "America/Chicago",
  MA: "America/New_York",
  MD: "America/New_York",
  ME: "America/New_York",
  MI: "America/Detroit",
  MN: "America/Chicago",
  MO: "America/Chicago",
  MS: "America/Chicago",
  MT: "America/Denver",
  NC: "America/New_York",
  ND: "America/Chicago",
  NE: "America/Chicago",
  NH: "America/New_York",
  NJ: "America/New_York",
  NM: "America/Denver",
  NV: "America/Los_Angeles",
  NY: "America/New_York",
  OH: "America/New_York",
  OR: "America/Los_Angeles",
  PA: "America/New_York",
  RI: "America/New_York",
  SC: "America/New_York",
  SD: "America/Chicago",
  TN: "America/Chicago",
  TX: "America/Chicago",
  UT: "America/Denver",
  VA: "America/New_York",
  VT: "America/New_York",
  WA: "America/Los_Angeles",
  WI: "America/Chicago",
  WV: "America/New_York",
  WY: "America/Denver",
};

export const timezoneForState = (stateShort) => {
  const key = String(stateShort || "")
    .trim()
    .toUpperCase();
  return STATE_TIMEZONES[key] || DEFAULT_SIGNUP_TIMEZONE;
};

export const timezoneForSquad = (squad) =>
  timezoneForState(
    squad?.bowlingCenters?.stateShort ||
      squad?.bowlingCenter?.stateShort ||
      squad?.stateShort
  );

const pad2 = (value) => String(value).padStart(2, "0");

export const padSquadTime = (squadTime) => {
  const raw = String(squadTime || "00:00:00");
  if (/^\d{2}:\d{2}$/.test(raw)) return `${raw}:00`;
  return raw.slice(0, 8);
};

const zoneParts = (date, timeZone) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value;
  return {
    year: Number(get("year")),
    month: Number(get("month")),
    day: Number(get("day")),
    hour: Number(get("hour")),
    minute: Number(get("minute")),
    second: Number(get("second")),
  };
};

export const wallClockInZone = (dateStr, timeStr, timeZone) => {
  if (!dateStr) return null;
  const date = String(dateStr).slice(0, 10);
  const time = padSquadTime(timeStr);
  const [year, month, day] = date.split("-").map(Number);
  const [hour, minute, second] = time.split(":").map(Number);
  if (![year, month, day, hour, minute].every((n) => Number.isFinite(n))) {
    return null;
  }
  const zone = timeZone || DEFAULT_SIGNUP_TIMEZONE;
  const utcGuess = Date.UTC(
    year,
    month - 1,
    day,
    hour,
    minute,
    Number.isFinite(second) ? second : 0
  );
  const asUtc = new Date(utcGuess);
  const shown = zoneParts(asUtc, zone);
  const shownAsUtc = Date.UTC(
    shown.year,
    shown.month - 1,
    shown.day,
    shown.hour,
    shown.minute,
    shown.second
  );
  const instant = new Date(utcGuess - (shownAsUtc - utcGuess));
  return Number.isNaN(instant.getTime()) ? null : instant;
};

export const toDatetimeLocalValue = (iso, timeZone) => {
  if (!iso) return "";
  const date = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const shown = zoneParts(date, timeZone || DEFAULT_SIGNUP_TIMEZONE);
  return `${shown.year}-${pad2(shown.month)}-${pad2(shown.day)}T${pad2(
    shown.hour
  )}:${pad2(shown.minute)}`;
};

export const fromDatetimeLocalValue = (localValue, timeZone) => {
  if (!localValue) return null;
  const [date, time] = String(localValue).split("T");
  const instant = wallClockInZone(date, time, timeZone);
  return instant ? instant.toISOString() : null;
};
